import { useCallback, useEffect, useState } from "react";
import { CarouselApi } from "../@shadcn/components/ui/carousel";

type UseAutoScrollType = {
  autoScrollIsPlaying: boolean;
  stopAutoScroll: () => void;
  resumeAutoScroll: () => void;
};

export const useAutoScroll = (
  emblaApi: CarouselApi | undefined
): UseAutoScrollType => {
  const [autoScrollIsPlaying, setAutoScrollIsPlaying] = useState(false);

  const stopAutoScroll = useCallback(() => {
    const autoScroll = emblaApi?.plugins()?.autoScroll;
    if (!autoScroll) return;
    autoScroll.stop();
  }, [emblaApi]);

  const resumeAutoScroll = useCallback(() => {
    const autoScroll = emblaApi?.plugins()?.autoScroll;
    if (!autoScroll) return;
    autoScroll.play();
  }, [emblaApi]);

  useEffect(() => {
    const autoScroll = emblaApi?.plugins()?.autoScroll;
    if (!autoScroll) return;

    setAutoScrollIsPlaying(autoScroll.isPlaying());
    emblaApi
      .on("autoScroll:play", () => setAutoScrollIsPlaying(true))
      .on("autoScroll:stop", () => setAutoScrollIsPlaying(false))
      .on("reInit", () => setAutoScrollIsPlaying(autoScroll.isPlaying()));
  }, [emblaApi]);

  return {
    stopAutoScroll,
    resumeAutoScroll,
    autoScrollIsPlaying,
  };
};
